import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
    children: React.ReactChild | React.ReactChildren;
    mountToNode: Element;
}

const Portal = (props: Props) => {
    const mount = props.mountToNode;
    return createPortal(props.children, mount);
};

export default Portal;
